var render, staticRenderFns
import script from "./queue_manage.vue?vue&type=script&lang=js&"
export * from "./queue_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf7346e')) {
      api.createRecord('4cf7346e', component.options)
    } else {
      api.reload('4cf7346e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/queue_manage/queue_manage.vue"
export default component.exports